import type { GTM } from "../../../../legacy/services/gtmEvent/GTMInterfaces";
import { sendGTMEvent } from "../../../../legacy/services/gtmEvents";

export function sendChatbotPanelOpenedGtmEvent(): void {
  const EVENT_NAME = "chatbot-panel-opened";

  const eventData: GTM.Event = {
    event: EVENT_NAME,
    url: window.location.href,
    mixpanelTrackedBySdk: true,
  };

  sendGTMEvent(eventData);
}
